import React from 'react';
import Footer from './components/Footer';
import Home from './components/Home/Home';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import WriteHere from './components/writeHere/WriteHere';
import ShowAddress from './components/writeHere/ShowAddress';
import Approve from './components/writeHere/Approve';
import ShowApprove from './components/writeHere/ShowApprove';
import ApprovePaid from './components/writeHere/ApprovePaid';
import Files from './components/writeHere/Files';
// import Particles from 'react-particles-js'

function App() {
  return (
    <div className="App">
      
      {/* <main id="main"> */}

      <Router >
        <Routes>
        <Route exact path="/Share-it-later/" element={<React.Fragment><Navbar showMenu={true} /><Home /><Footer /></React.Fragment>} />

          <Route
            path="writehere"
            element={<React.Fragment><WriteHere /></React.Fragment>}
          />
          <Route
            path="showAddress"
            element={<React.Fragment><ShowAddress /></React.Fragment>}
          />
          <Route
            path="Approve"
            element={<React.Fragment><Approve /></React.Fragment>}
          />
          <Route
            path="ApprovePaid"
            element={<React.Fragment><ApprovePaid /></React.Fragment>}
          />
           <Route
            path="ShowApprove"
            element={<React.Fragment><ShowApprove /></React.Fragment>}
          />
           <Route
            path="files"
            element={<React.Fragment><Files /></React.Fragment>}
          />
        </Routes>
      </Router>
      {/* </main> */}

    </div>
  );
}

export default App;
